import { GroupResponse, GroupResponseV2 } from 'api/httpEntities';

const isGroupResponse = (
  group: any,
): group is GroupResponse | GroupResponseV2 => {
  return (
    'type' in group &&
    'name' in group &&
    ('organisations' in group || 'organisationsCount' in group)
  );
};

export default isGroupResponse;
